// 系统更新日志数据（/version 页面渲染源）
// 维护规则：每次系统功能更新发布时，必须在数组最前面新增一条记录（按时间倒序排列）。
// 字段说明：
//   timestamp  更新时间，格式 YYYY/MM/DD（或 YYYY/MM）
//   items      本次更新点列表，每项包含 title（更新标题）与 lines（面向业务用户的说明，可多行）
//   text       简单条目可只写一段文字（与 items 二选一）
//   hidden     为 true 时不在页面展示（用于归档较早的历史记录）
const changelog = [
  {
    timestamp: '2026/07/31',
    items: [
      {
        title: '修复入库选择款式后品牌/工厂等信息显示为星号的问题',
        lines: ['修复了操作入库时，在添加入库货品弹框中选择入库款式后，品牌名称、工厂名称、品牌款号、工厂款号等显示为星号（*）并导致保存失败的问题；现在选择款式后会直接带出完整的款式信息，可正常提交入库。'],
      },
    ],
  },
  {
    timestamp: '2026/07/29',
    items: [
      {
        title: '修复退货入库品牌名称等信息显示为星号的问题',
        lines: ['修复了售后单执行退货入库时，品牌名称、工厂名称等信息显示为星号（*）导致提交入库提示"品牌名称不能包含*字符"的问题；现在生成退货入库数据时会自动用货品档案和售后单中的完整信息还原这些字段，无法还原的字段将留空，可在入库页面手工补录后提交。'],
      },
    ],
  },
  {
    timestamp: '2026/07/28',
    items: [
      {
        title: 'SKU维护页面费用字段调整',
        lines: ['SKU维护页面中“费用克重”“基础工费”“金工费”调整为只读展示，不再支持手工修改；原“标准克重”更名为“样板克重”，含义不变；其他费用区域新增“入网费”字段，可在维护SKU时录入。同时移除了标准工费提示行，费用输入框内容改为居左展示，并在输入提示文字中标注了单位与计算公式，录入更直观。'],
      },
      {
        title: '修复退货入库款号显示为星号的问题',
        lines: ['修复了售后单执行退货入库时，款号、批次号等信息被保存成星号（***）导致切换明文展示也无法查看的问题；现在退货入库会自动使用售后单的完整信息生成入库数据，并在保存前拦截含星号的异常数据。'],
      },
    ],
  },
  {
    timestamp: '2026/07',
    items: [
      {
        title: '新增库存待处理单据页面',
        lines: ['新增库存待处理单据页面，出入库单据可先登记为待处理状态，支持后续继续处理或取消待处理的退货单据。'],
      },
      {
        title: '生产订单打印升级',
        lines: ['生产订单支持条码打印，生产订单明细展示优化，查看更清晰。'],
      },
      {
        title: '售后退货模块优化',
        lines: ['退货订单列表增加平台名称展示；退货导入模板支持更多退货类型并更新了模板下载地址，导入校验提示更明确。'],
      },
      {
        title: '货品成本信息完善',
        lines: ['货品档案成本费用板块重新整理，新增标准费用自动计算；货品明细增加重量与工费字段。'],
      },
      {
        title: '借货申请优化',
        lines: ['借货申请单批次号匹配逻辑优化，匹配失败时给出更明确的错误提示。'],
      },
    ],
  },
  {
    timestamp: '2026/06',
    items: [
      {
        title: '商城支付能力升级',
        lines: ['商城小程序支持在线支付，外部支付新增支付宝支付入口。'],
      },
      {
        title: '拼多多多部门授权',
        lines: ['拼多多平台支持多部门分别授权与订单同步，各部门数据相互独立。'],
      },
      {
        title: '页面体验优化',
        lines: ['优化首页预览与审批流程页面展示效果；借出页面权限控制优化。'],
      },
    ],
  },
  {
    timestamp: '2026/05',
    items: [
      {
        title: '采购模块中文化',
        lines: ['采购模块界面与单据字段全面中文化，使用更贴合日常业务习惯。'],
      },
      {
        title: '外部支付二维码',
        lines: ['新增外部支付二维码与独立支付页面，客户扫码即可完成付款。'],
      },
      {
        title: '借货申请流程完善',
        lines: ['完善借货申请单的保存与审核流程。'],
      },
      {
        title: '广发订单地址解析',
        lines: ['广发平台订单收货地址自动解析省市区，减少手工整理。'],
      },
      {
        title: '小程序体验优化',
        lines: ['小程序商品页与订单退款页翻页体验优化；产品搜索列权限与表格重置功能优化。'],
      },
    ],
  },
  {
    timestamp: '2026/04',
    items: [
      {
        title: '唯品会平台接入',
        lines: ['新增唯品会平台对接，订单每25分钟自动增量同步，无需手工导入。'],
      },
      {
        title: '公司/组织筛选器',
        lines: ['列表页面新增公司与组织筛选器，可按系统配置控制显隐，跨公司数据查询更方便。'],
      },
      {
        title: '账号安全与管理优化',
        lines: ['钉钉离职人员账户自动禁用；管理员重置密码功能优化。'],
      },
      {
        title: '字典维护优化',
        lines: ['字典维护支持分页查询与查询类型筛选，维护大量字典更流畅。'],
      },
      {
        title: '库存批量修改优化',
        lines: ['库存批量修改支持字段留空表示不修改，避免误清空已有数据。'],
      },
      {
        title: '广发多部门配置',
        lines: ['广发平台支持按部门绑定账号配置；供应商字段增加权限管控。'],
      },
    ],
  },
  {
    timestamp: '2026/03',
    items: [
      {
        title: '更新升级表格组件',
        lines: ['增加表格列权限的脱敏以及权限控制功能，增加表格列拖拽排序及保存功能。'],
      },
      {
        title: '增加账户的公司数据范围权限',
        lines: ['系统账户默认仅可查阅管理其架构下的数据权限，如需管理更多公司的数据权限，请联系部门经理申请权限。'],
      },
      {
        title: '货品档案维度扩展',
        lines: ['货品SPU/SKU档案扩展多个业务维度字段，并按业务分组Tab展示维护；出入库单据新增含税价格字段及校验。'],
      },
      {
        title: '跨公司调拨升级',
        lines: ['跨公司调拨支持批量添加，接收方可按明细逐条接收或拒绝，也支持拒绝接收整单。'],
      },
      {
        title: '公告自动推送',
        lines: ['发文审核通过后自动推送公告通知相关人员。'],
      },
      {
        title: '登录安全升级',
        lines: ['登录密码全程加密传输，账户安全性提升。'],
      },
    ],
  },
  {
    hidden: true,
    timestamp: '2023/09/10',
    items: [
      {
        title: '清理系统缓存(浏览器缓存)',
        lines: [
          '在申请流程或者进销存功能模块中，如果有新添加的字典没有更新出来可以点击系统右上角的清理缓存刷新页面展示数据',
          '优化时间 2023/09/10',
        ],
      },
    ],
  },
  {
    hidden: true,
    timestamp: '2023/08/01',
    items: [
      {
        title: '各渠道订单同步',
        lines: [
          '系统自动同步各个渠道的订单并且支持各个平台的订单快递单打印等',
          '截至2023年09月支持小米有品/招行平台的自动化订单流程',
        ],
      },
    ],
  },
  {
    hidden: true,
    timestamp: '2023/06/01',
    items: [
      {
        title: '办公系统报销流程',
        lines: [
          '财务相关的报销流程电子化。目前支持费用报销/请款申请/借款申请等流程',
          '提出人 李莹 2023/05/15',
        ],
      },
    ],
  },
  {
    hidden: true,
    timestamp: '2023/04/20',
    items: [
      {
        title: '盘点模块增加微信扫一扫功能',
        lines: ['盘点模块支持微信扫码快速盘点；', '提出人 乔源涛 2023/04/20'],
      },
    ],
  },
  {
    hidden: true,
    timestamp: '2023/03/17',
    items: [
      {
        title: '入库模块增加多库房入库功能',
        lines: ['入库模板新增库房列、入库列表增加库房下拉选择框；', '提出人 袁炯 2023/03/17'],
      },
    ],
  },
  {
    hidden: true,
    timestamp: '2023/02/01-2023/03/15',
    items: [
      {
        title: '抖音订单以及店管家抖音订单模块',
        lines: ['提出人 李素慧 2023/02/01'],
      },
    ],
  },
  {
    hidden: true,
    timestamp: '2022/6/1',
    items: [
      {
        title: '快递费用计算模块',
        lines: ['兼容接入顺丰各类型快递、圆通快递等快递计算以及出入库费用计算'],
      },
    ],
  },
  {
    timestamp: '2021-2022',
    text: '……',
  },
  {
    timestamp: '2021/10/1',
    text: '新版进销存上线',
  },
  {
    timestamp: '2019/6/1',
    text: '项目启动及上线',
  },
]

export default changelog
